import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { portalApi, apiError, LOGO_URL } from "@/lib/api";
import { PageBackground } from "@/components/PageBackground";
import { Talbiyah, GLASS, SHELL } from "@/components/Talbiyah";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2, Plane, Briefcase } from "lucide-react";

export default function CustomerLogin() {
  const navigate = useNavigate();
  const [f, setF] = useState({ phone: "", secret: "" });
  const [loading, setLoading] = useState(false);
  const [both, setBoth] = useState(null);

  const goPilgrim = (p) => { localStorage.setItem("portal_token", p.token); toast.success(`Assalamu Alaikum, ${p.contact.name}`); navigate("/portal/home"); };
  const goJob = (j) => { localStorage.setItem("candidate_token", j.token); toast.success(`Welcome, ${j.candidate.name}`); navigate("/jobs"); };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await portalApi.post("/customer/login", f);
      if (data.pilgrim && data.job) setBoth(data);
      else if (data.pilgrim) goPilgrim(data.pilgrim);
      else goJob(data.job);
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={SHELL}>
      <PageBackground dim={0.04} />
      <Talbiyah />
      <div className={`w-full max-w-[380px] fade-in ${GLASS}`} data-testid="customer-login-page">
        <div className="flex flex-col items-center text-center mb-6">
          <img src={LOGO_URL} alt="Bengal Umrah House" className="w-28 h-28 rounded-full object-cover ring-2 ring-gold/70 shadow-[0_0_45px_rgba(212,175,55,0.4)]" />
          <h1 className="font-serif text-2xl font-semibold text-white mt-4">Customer Login</h1>
          <p className="eyebrow text-gold">Umrah Pilgrim · Job Seeker</p>
        </div>
        {both ? (
          <div className="space-y-3" data-testid="customer-login-choose">
            <p className="text-sm text-center text-muted-foreground">You have both accounts. Where do you want to go?</p>
            <Button onClick={() => goPilgrim(both.pilgrim)} data-testid="customer-login-go-pilgrim" className="w-full bg-gold text-[#0a2e22] hover:bg-gold/90 gap-2"><Plane className="w-4 h-4" /> Umrah Pilgrim Portal</Button>
            <Button onClick={() => goJob(both.job)} variant="outline" data-testid="customer-login-go-job" className="w-full border-gold/40 text-gold gap-2"><Briefcase className="w-4 h-4" /> Jobs Portal</Button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="customer-login-form">
            <div><Label className="text-xs text-muted-foreground">Mobile number</Label>
              <Input data-testid="customer-login-phone" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} placeholder="+9198XXXXXXXX" className="mt-1.5 bg-card/60" required /></div>
            <div><Label className="text-xs text-muted-foreground">Your name (pilgrim) or password (job seeker)</Label>
              <Input data-testid="customer-login-secret" type="password" value={f.secret} onChange={(e) => setF({ ...f, secret: e.target.value })} placeholder="Name given at booking / job password" className="mt-1.5 bg-card/60" required /></div>
            <Button type="submit" disabled={loading} data-testid="customer-login-submit" className="w-full bg-gold text-[#0a2e22] hover:bg-gold/90 font-semibold">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Log in"}
            </Button>
          </form>
        )}
        <div className="mt-6 grid grid-cols-2 gap-2 text-center">
          <Link to="/portal" data-testid="customer-login-new-pilgrim" className="text-xs text-gold underline underline-offset-2">New pilgrim? Register</Link>
          <Link to="/jobs" data-testid="customer-login-new-job" className="text-xs text-gold underline underline-offset-2">Looking for a job? Register</Link>
        </div>
      </div>
    </div>
  );
}
